import React, { Component } from 'react';

class Index extends Component {
  constructor(props) {
    super(props)
    window.location = "https://shop.wkndbrand.com";
  }

  render() {
    return (
      <div className="site-wrap">
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/Index.js